import { render } from "./AbnormalLighting.vue?vue&type=template&id=0548d60d&scoped=true&ts=true"
import script from "./AbnormalLighting.vue?vue&type=script&lang=ts"
export * from "./AbnormalLighting.vue?vue&type=script&lang=ts"

import "./AbnormalLighting.vue?vue&type=style&index=0&id=0548d60d&scoped=true&lang=css"
import "./AbnormalLighting.vue?vue&type=style&index=1&id=0548d60d&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0548d60d"]])

export default __exports__